<template>
	<div class="c-controls">
		<div class="c-controls__group">
			<label class="c-controls__label">Winnaar</label>
			<select v-model="team" @change="chooseVictor()">
				<option v-for="team in teams" :key="team.uuid" :value="team.uuid">
					{{ team.name }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
import BaseSlide from './BaseSlide';

export default {
	name: 'NieuwsmakerVoteSlide',
	mixins: [BaseSlide],
  methods: {
    chooseVictor() {
      window.axios.post(`/api/v1/victor/${this.slide.uuid}`, {
        team: this.team,
      }).then(x => {
        console.log('posting victor complete');
      });
    },
  },
  data() {
    return {
      team: null,
    };
  },
	computed: {
		teams() {
			// TODO: teams met nieuwsmaker inzendingen ipv alle teams
			return this.$actions.getTeams();
		},
	},
};
</script>

<style></style>
